import PasswordFeedback from './PasswordFeedback';

export { default as PasswordFeedback } from './PasswordFeedback';
export type { PasswordFeedbackProps } from './PasswordFeedback';
